import { Directive, ElementRef, Input, Renderer2 } from '@angular/core';
import { CriterionsService } from '../../services/criterions.service';

@Directive({
  selector: '[allowedSummaryType]'
})
export class AllowedSummaryTypeDirective {
  @Input('allowedSummaryType') values: string[];

  constructor(private el: ElementRef,
    private renderer: Renderer2,
    private criterionsService: CriterionsService) { }

  ngOnInit() {
    this.criterionsService.decisionInputs$.subscribe((decisionInputs) => {
      if (!this.values.some(q => q == decisionInputs.evaluatedSummaryType)) {
        this.renderer.setStyle(this.el.nativeElement, 'display', 'none');
      }
    });
  }
}